import type { NextPage } from "next";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import Image from "../../app/component/commons/image/Image";
import Meta from "../../app/component/commons/meta/Meta";
import {
  PopoverOne,
  PopoverTwo,
} from "../../app/component/commons/popover/Popover";
import {
  customer_satisfaction,
  history,
  improve,
  weDoIt_1,
  weDoIt_2,
} from "../../app/helpers/ContentList";
import DefaultLayout from "../../app/layouts/DefaultLayout";

const Index: NextPage = () => {
  const [mode, setMode] = useState("");
  const router = useRouter();

  useEffect(() => {
    // window.analytics.page("viewed");
    if (window.innerWidth < 768) {
      setMode("mobile");
    } else {
      setMode("desktop");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Meta
        title="About | Storage Unit Auction List"
        description="Storage Unit Auction list is a website that lists all the storage unit auctions happening in the United States. There are tens of thousands of auctions each month, so there is always something happening near you."
      />
      <DefaultLayout nearFoot={false} topFooter="md:!mt-[7.75rem] mt-[5.25rem]">
        <div className="container mx-auto ">
          <div className="mt-[5.75rem] flex flex-col items-center justify-center text-center">
            <div className="text-warning-500 text-regular-tight md:text-large-none md:font-bold font-medium uppercase">
              Company
            </div>
            <div className="mt-4 md:mt-3.5 text-neutral-900 font-bold md:!text-title1 text-title3 leading-[2.125rem]">
              About Us
            </div>
          </div>

          <div className="mt-4 md:mt-14 bg-map-desktop-2 bg-contain md:bg-auto bg-top bg-no-repeat min-h-[36rem] lg:w-[62rem] xl:w-[68.125rem] mx-auto">
            <div className="flex flex-row items-center justify-between px-3 md:h-auto h-[8rem]">
              <div className="shadow-lv5 bg-white p-4.5 w-[18.875rem] rounded-xl md:block hidden">
                <PopoverOne visible animate="" />
              </div>
              <div className="shadow-lv4 bg-white p-3.5 w-[20.625rem] rounded-xl md:block hidden">
                <PopoverTwo visible animate="" />
              </div>
            </div>
            <div className="md:mt-[7.438rem] gradient-main md:rounded-[3rem] w-full p-4.5 md:p-[2.375rem]">
              <div className="text-large-normal md:text-title2 text-neutral-900 font-bold">
                Our History
              </div>
              <div className="mt-3.5 md:mt-4.5 text-neutral-700 text-small-normal md:text-xl md:leading-10 text-justify">
                <p>{history["paragraf-1"]}</p>
                <p className="md:mt-4.5">{history["paragraf-2"]}</p>
              </div>
            </div>
          </div>

          <div className="mt-8 md:mt-12 flex flex-col md:flex-row items-center md:items-start lg:items-center md:space-x-3 xl:space-x-5 lg:w-[61rem] xl:w-[68.125rem] mx-auto px-4.5 md:px-0">
            <div className="min-w-[10.188rem] md:min-w-[20.5rem] relative">
              <div className="absolute left-[1rem] top-[1rem] md:left-10 md:top-7 bg-[#F0F5FF] rounded-[1.875rem] w-[7.951rem] h-[7.951rem] md:w-64 md:h-64 z-0"></div>
              <Image
                src="/images/map-color.png"
                alt="about-us"
                className="w-[10.188rem] md:w-full z-10 relative"
              />
            </div>
            <div className="flex flex-col space-y-3 md:space-y-6">
              <div className="text-neutral-900 font-bold text-large-normal md:text-title2 text-center md:text-left">
                We are only going to improve
              </div>
              <div className="text-neutral-700 text-small-normal md:text-xl md:leading-[1.875rem] text-justify md:pr-10">
                {improve["paragraf-1"]}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 md:mt-[7.75rem] relative">
          <div className="absolute rounded-full left-[-5rem] bottom-[4rem] bg-primary-50 w-[10.125rem] h-[10.125rem] z-0 hidden md:block"></div>
          <div className="absolute rounded-full right-[-5rem] bottom-[7rem] bg-secondary-50 w-[10.125rem] h-[10.125rem] z-0 md:block hidden"></div>
          <div className="container mx-auto ">
            <div className="flex flex-col justify-center items-center lg:w-[68.125rem] mx-auto md:px-0 px-4.5 ">
              <div className="relative">
                <div className="absolute left-[-1.5rem] top-[-1rem]  lg:left-[-10rem] lg:top-[1rem] xl:left-[-15rem] xl:top-[1rem] z-0">
                  <Image
                    src="/images/avatar/new-circle-1.svg"
                    alt="about-us"
                    className="lg:w-[6.563rem] lg:h-[6.563rem] md:w-14 md:h-14 w-7 h-7"
                  />
                </div>
                <div className="absolute left-[-2rem] top-full lg:left-[-8rem] lg:top-[15rem] xl:left-[-10rem] xl:top-[15rem] z-0">
                  <Image
                    src="/images/avatar/new-circle-2.svg"
                    alt="about-us"
                    className="md:w-[4.25rem] md:h-[4.25rem] w-[2.875rem] h-[2.875rem]"
                  />
                </div>
                <div className="absolute right-[-1rem] top-full md:right-[-3rem] md:top-[1rem] lg:right-[-5rem] lg:top-[1rem] xl:right-[-15rem] xl:top-[1rem] z-0">
                  <Image
                    src="/images/avatar/new-circle-1.svg"
                    alt="about-us"
                    className="md:w-[2.875rem] md:h-[2.875rem] w-[2.125rem] h-[2.125rem]"
                  />
                </div>
                <div className="absolute right-[-2rem] top-[-2rem] md:right-[-5rem] md:top-[16rem] lg:right-[-7rem] xl:right-[-12rem] lg:top-[14rem] z-0">
                  <Image
                    src="/images/avatar/new-circle-4.svg"
                    alt="about-us"
                    className="md:w-24 md:h-24 w-12 h-12"
                  />
                </div>

                <div className="text-neutral-900 font-bold text-large-normal md:text-[2.5rem] md:leading-[3.5rem] text-center">
                  {customer_satisfaction["title"]}
                </div>
                <div className="mt-3 md:mt-6 text-neutral-700 text-small-normal md:text-xl md:!leading-[1.875rem] text-justify md:text-center md:w-[40.5rem] break-words md:break-normal">
                  <p>{customer_satisfaction["paragraf-1"]}</p>
                </div>
              </div>
              <div className="mt-[2.375rem] w-full md:w-[20.625rem] shadow-lv4 bg-white flex flex-col items-center justify-center p-3.5 rounded-xl">
                <div className="font-bold text-neutral-900 text-title3">
                  Thank You 😊
                </div>
                <div className="text-center text-small-normal text-neutral-600 mt-2">
                  {" "}
                  for choosing Storage Unit Auction List, we look forward to
                  growing each day with you!
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto ">
          <div className="mt-[5.25rem] md:mt-[7.75rem] flex flex-col items-center justify-center w-full lg:w-[54.25rem] mx-auto">
            <div className="text-neutral-900 font-bold text-title4 leading-[2.125rem] md:text-title1 md:!text-[2.5rem] text-center md:w-[40rem] px-4.5 md:px-0">
              The Complex Inner workings of{" "}
              <span className="text-gradient-7 block">
                StorageUnitAuctionList.com
              </span>{" "}
              How We Do It?
            </div>
            <div className="mt-6 md:mt-12 relative flex flex-col items-center justify-center w-full">
              <div className="absolute z-0 top-[3rem] gradient-main rounded-[3rem] w-full md:w-[40.25rem] h-full md:h-[19.375rem]"></div>
              <div className="flex flex-col md:flex-wrap md:flex-row justify-center items-center md:gap-x-[2.125rem] gap-y-3.5 relative w-full md:px-0 px-4.5">
                {[...weDoIt_1, ...weDoIt_2].map((e, key: number) => (
                  <div
                    key={key}
                    className="w-full md:w-5/12 lg:w-[16.5rem] bg-white shadow-lv4 rounded-3xl py-4.5 px-[1.375rem] flex flex-col items-center justify-center"
                  >
                    <div className={`rounded-[0.875rem] p-3.5 ${e.className}`}>
                      <e.Icon size="34" />
                    </div>
                    <div className="font-bold text-neutral-900 text-title3 mt-6">
                      {e.title}
                    </div>
                    <div className="text-large-normal text-neutral-900 mt-3">
                      {e.subtitle}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
};

export default Index;
